module.exports = __webpack_public_path__ + "img/link_text.ef0e02bb.svg";